module.exports = __webpack_public_path__ + "static/11-formation-deformation-s-vii-eb9e395d49cc8bf3ddef4bc651e98598.jpg";